// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3s-Is","newExpiryDate":"styles_newExpiryDate__aaA2b","footer":"styles_footer__HDHq4"};